export const LoadingComponent: React.FC = () => {
  return (
    <div className="flex flex-col p-4 gap-y-8 rounded-lg border border-primary-300 dark:border-primary-800 bg-white dark:bg-default-dark">
      {Array.from({ length: 3 }).map((_, idx) => {
        return (
          <div key={idx} className="flex flex-col gap-y-4">
            <div className="h-3 rounded-md w-full animate-pulse bg-primary-300 dark:bg-primary-700" />
            <div className="h-3 rounded-md w-full animate-pulse bg-primary-300 dark:bg-primary-700" />
            <div className="h-3 rounded-md w-3/4 animate-pulse bg-primary-300 dark:bg-primary-700" />
            <div className="h-3 rounded-md w-1/2 animate-pulse bg-primary-300 dark:bg-primary-700" />
            <div className="h-3 rounded-md w-3/4 animate-pulse bg-primary-300 dark:bg-primary-700" />
            <div className="h-3 rounded-md w-1/2 animate-pulse bg-primary-300 dark:bg-primary-700" />
          </div>
        )
      })}
    </div>
  )
}
